import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaRadio'

type IcaRadioProps = React.JSX.IntrinsicElements['tgdb-ica-radio']

export const IcaRadio = wrapWc<IcaRadioProps>('tgdb-ica-radio', [])